// File: src/router/config.tsx
// import { createBrowserRouter } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';
import MobileStickyCTA from '../components/feature/MobileStickyCTA';

import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import Datenschutz from '../pages/datenschutz/page';
import Impressum from '../pages/impressum/page';
import About from '../pages/about/page';
import Kontakt from '../pages/kontakt/page';
import Leistungen from '../pages/leistungen/page';
import ServiceDetailPage from '../pages/leistungen/detail';
import EinsatzgebietePage from '../pages/einsatzgebiete/page';
import NotrufPage from '../pages/notruf/page';
import Faq from '../pages/faq/page';
import CookieSettingsPage from '../pages/cookie/page';

function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <header>
        <Header />
      </header>
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'home', element: <Home /> },
      { path: 'about', element: <About /> },
      { path: 'leistungen', element: <Leistungen /> },
      { path: 'leistungen/:slug', element: <ServiceDetailPage /> },
      { path: 'einsatzgebiete', element: <EinsatzgebietePage /> },
      { path: 'notruf', element: <NotrufPage /> },
      { path: 'kontakt', element: <Kontakt /> },
      { path: 'faq', element: <Faq /> },
      { path: 'cookie', element: <CookieSettingsPage /> },
      { path: 'datenschutz', element: <Datenschutz /> },
      { path: 'impressum', element: <Impressum /> },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default routes;
